export default __webpack_public_path__ + "static/media/baya-bird.151f4a90.jpg";